import React from 'react';
import { FaShareAlt, FaPlus } from 'react-icons/fa';

const TeamMemberHeader = ({ onShare, onOpenAdd, viewMode }) => {
  return (
    <div className="mtm-main-header">
      <div className="mtm-brand-header">
        <h5>Team / Point of Contact</h5>
        <p className="text-muted small m-0 d-none d-md-block">
          Manage staff roles, granular module permissions, and member release status.
        </p>
      </div>
      <div className="mtm-header-actions">
        <button onClick={onShare} className="mtm-btn-share" title="Share Profile">
          <FaShareAlt /> <span className="d-none d-md-inline">Share Profile</span>
        </button>
        {viewMode === 'list' && (
          <button className="mtm-btn-primary" onClick={onOpenAdd} title="Add Member">
            <FaPlus /> 
            <span className="d-none d-md-inline">Add Member</span>
            <span className="d-md-none">Add</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TeamMemberHeader;
